/**
 * グローバル変数定義
 */
window.St = window.St || {
  // モーダルダイアログユニーク判定（画面になにか出てたらtrue）
  modal: false,
};
